module.exports = __webpack_public_path__ + "img/alfie-w14.c79805fe.jpeg";